import { Button, Flex, Modal, Typography, message } from "antd";
import { useState } from "react";
import { useAppSelector } from "../../hooks/redux-hooks";
import { membersService } from "../../service/members.service";
import { UserTier } from "../../slices/authSlice";

const { Text, Title } = Typography;

const BillingInactiveModal = () => {
  const { userInfo } = useAppSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  // Include is_group_admin: subscription deletion downgrades the payer to
  // FREE tier, and they must still get this modal (not the solo paywall).
  const isGroupUser = userInfo.tier === UserTier.GROUP || userInfo.is_group_admin;
  const isBillingInactive = isGroupUser && userInfo.group_billing_active === false;
  const isAdmin = userInfo.is_group_admin;

  const handleManageBilling = async () => {
    setLoading(true);
    // Open synchronously in the click gesture — Safari blocks window.open
    // after an await. Billing period is omitted so the backend restores the
    // group's previous cadence.
    const billingTab = window.open("", "_blank");
    try {
      // Backend routes: overdue invoice, billing portal, or new subscription.
      const { payment_link } = await membersService.generateGroupPaymentLink();
      if (billingTab) {
        billingTab.location.href = payment_link;
      } else {
        window.location.href = payment_link;
      }
    } catch {
      billingTab?.close();
      message.error("Couldn't open the billing page. Please try again or contact support@getnudgeai.com.");
    } finally {
      setLoading(false);
    }
  };

  if (!isBillingInactive) return null;

  return (
    <Modal open closable={false} footer={null} centered maskClosable={false} zIndex={1200}>
      <Flex vertical gap={16} align="center" style={{ padding: "16px 0" }}>
        <Title level={4} style={{ margin: 0 }}>
          Subscription Inactive
        </Title>
        {isAdmin ? (
          <>
            <Text style={{ textAlign: "center" }}>
              Your group's subscription is inactive due to a failed payment. Use the button below to pay the outstanding
              invoice or set up a new subscription — access is restored automatically once payment goes through.
            </Text>
            <Button type="primary" size="large" loading={loading} onClick={handleManageBilling}>
              Manage Billing
            </Button>
            <Button type="link" href="/members">
              Go to Member Management
            </Button>
          </>
        ) : (
          <>
            <Text style={{ textAlign: "center" }}>
              Your group's subscription is currently inactive. Please contact your group administrator to restore
              access.
            </Text>
            {userInfo.group_name && <Text type="secondary">Group: {userInfo.group_name}</Text>}
          </>
        )}
      </Flex>
    </Modal>
  );
};

export default BillingInactiveModal;
